<form [formGroup]="vehicleForm" (ngSubmit)="AddEditVehicle(false)">
  <div class=" scrollbar longtab" *ngIf="showVehicleEditForm">

    <div class="p-2">

      <div class="">
        <div class="cst-acc-card mb20" *ngIf="IsSearch">
          <div class="row mb-3" style="display: none;">
            <div class="col-12">
              <p class="text-danger" translate>
                lblInfoRegistrationVINNo
                </p>
            </div>
          </div>
          <div class="row align-items-start">
            <div class="col-3" *ngIf="IsSearch && isEditFromCustomer == false">
              <div class="af-form-group mb-0" >
                <label for="template-licensePlate" ><span translate> lblRegNumber </span> / <span translate> lblVinNumber </span> <strong class="required">*</strong> 
                  </label>
                <div class="lbl-info">
                  <div class="d-flex">
                    <input type="text" id="template-licensePlate" name="licensePlate" formControlName="licensePlate"
                    class="form-control radius-rb-flat" placeholder="" required maxlength="50"
                    [ngClass]="{'ng-select-is-invalid':(cpf.licensePlate.invalid  && isSearchFormValid)} "
                    (keyup.enter)="searchVehicle()">
                    <div class="input-group-append" *ngIf="IsSearch && isEditFromCustomer == false">
                      <button class="add-button btn btn-primary radius-lb-flat" type="button"
                        (click)="searchVehicle()" translate><em class="fa fa-search"></em></button>
                    </div>
                  </div>
                  <div *ngIf="(cpf.licensePlate.invalid  || (cpf.licensePlate.invalid  && isSearchFormValid))"
                    class="help-block text-danger w-100 text-left">
                    <div *ngIf="cpf.licensePlate.errors.required"><span translate>lblRequiredRegistrationVINNo</span>
                    </div>
                  </div>
                </div>

                
              </div>
            </div>
            
            
            <div class="col-3" *ngIf="IsSearch && !isAddFromAppointment">
              <div class="af-form-group mb-0">
                <label for="template-customerName" translate>lblCustomerName <strong class="required">*</strong></label>
                <div class="lbl-info">
                  <input type="text" id="template-customerName" name="customerName" formControlName="customerName"
                    class="form-control" placeholder="{{ 'lblEnterCustomerName' | translate }}" required maxlength="50"
                    [ngClass]="{'is-invalid':cpf.customerName.invalid  && cpf.customerName.touched}">
                  <div *ngIf="cpf.customerName.invalid  && (cpf.customerName.dirty || cpf.customerName.touched)"
                    class="help-block text-danger">
                    <div *ngIf="cpf.customerName.errors.required"><span translate>lblRequiredCustomerName</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-3" *ngIf="IsSearch && !isAddFromAppointment">
              <div class="af-form-group mb-0">
                <label for="template-ownerType" translate>lblOwnerType<strong class="mlt6 required">
                    *</strong> </label>
                <div class='lbl-info'>
                  <div>
                    <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="ownerTypeList" [ngClass]="{'ng-select-is-invalid':(cpf.ownerType.invalid  && cpf.ownerType.touched) || (cpf.ownerType.invalid  && isFormValid)}"
                      (ngModelChange)="onChangeService($event)" placeholder="{{ 'lblEnterOwnerType'| translate}}"
                      formControlName="ownerType" [(ngModel)]="selectedItems" [disabled]="isView">
                    </ng-multiselect-dropdown>
                  </div>
                  <div *ngIf="(cpf.ownerType.invalid && (cpf.ownerType.dirty || cpf.ownerType.touched)) || (cpf.ownerType.invalid && isFormValid)"
                    class="help-block text-danger">
                    <div *ngIf="cpf.ownerType.errors.required" class="lh-10px mt-2"><span translate>lblRequiredOwnerType</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="cst-acc-card mb20">
          <div class="row">
            <div class="col-3">
              <div class="af-form-group">
                <label for="template-regno" translate="">lblRegNumber <strong class="required">*</strong></label>
                <div class="lbl-info">
                  <input type="text" id="template-regno" name="regno" formControlName="regno" autocomplete="off"
                    class="form-control" placeholder="{{ 'lblEnterRegNo' | translate }}" required maxlength="50"
                    [ngClass]="{'ng-select-is-invalid':(cpf.regno.invalid) || (cpf.regno.invalid  && isFormValid)}">
                  <div *ngIf="(cpf.regno.invalid ) || (cpf.regno.invalid  && isFormValid)"
                    class="help-block text-danger">
                    <div *ngIf="cpf.regno.errors.required"><span translate>lblRequiredRegistrationNo</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="af-form-group">
                <label for="template-chassisNo" translate="">lblVinNumber <strong class="required">*</strong></label>
                <div class="lbl-info">
                  <input type="text" id="template-chassisNo" name="chassisNo" formControlName="chassisNo"
                    autocomplete="off" class="form-control" placeholder="{{ 'lblEnterVIN' | translate }}" required
                    maxlength="25" [ngClass]="{'ng-select-is-invalid':(cpf.chassisNo.invalid) || (cpf.chassisNo.invalid  && isFormValid)}">
                  <div *ngIf="(cpf.chassisNo.invalid) || (cpf.chassisNo.invalid  && isFormValid)"
                    class="help-block text-danger">
                    <div *ngIf="cpf.chassisNo.errors.required"><span translate>lblRequiredVIN</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-3">
              <div class="af-form-group">
                <label for="template-fueltype" translate>lblVehicleStatus<strong class="mlt6 required">
                    *</strong> </label>
                <div class='lbl-info'>
                  <ng-select formControlName="vehiclegroup" placeholder="{{ 'lblSelectVehicleStatus' | translate }}"
                    required [(ngModel)]="vehiclegroupName" [ngClass]="{'ng-select-is-invalid':(cpf.vehiclegroup.invalid) || (cpf.vehiclegroup.invalid  && isFormValid)}">
                    <ng-option *ngFor="let type of vehicleStatusList" [value]="type.vehicleStatus">
                      {{type.vehicleStatus}}</ng-option>
                  </ng-select>
                  <div *ngIf="(cpf.vehiclegroup.invalid || (cpf.vehiclegroup.invalid && isFormValid))"
                    class="help-block text-danger">
                    <div *ngIf="cpf.vehiclegroup.errors.required"><span translate>lblRequiredVehicleStatus</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-3">
              <label for="template-vehicletype" translate>lblVehicalType </label>
              <div class='lbl-info'>
                <ng-select formControlName="vehicletype" placeholder="{{ 'lblSelectVehical' | translate }}"
                  [(ngModel)]="vehicletypeName">
                  <ng-template ng-header-tmp>
                    <span class="mbold w-66px">Code</span>
                    <span class="mbold" translate>lblVehicalType</span>
                  </ng-template>

                  <ng-option *ngFor="let item of vehicleTypes" [value]="item.code">
                    <span class="w-66px">{{item.code}}</span>
                    <span class="mx-2 hide-ng-dropdown-panel">-</span>
                    <span>{{item.name}}</span>
                  </ng-option>
                </ng-select>
              </div>
            </div>


            <div class="col-3">
              <div class="af-form-group">
                <label for="template-make" translate>lblMake<strong class="mlt6 required">
                    *</strong> </label>
                <div class='lbl-info'>
                  <ng-select formControlName="makeCode" placeholder="{{ 'lblSelectMake' | translate }}" required
                    [(ngModel)]="makeName" (change)="onMakeSelected($event)" [ngClass]="{'ng-select-is-invalid':(cpf.makeCode.invalid) || (cpf.makeCode.invalid  && isFormValid)}">
                    <ng-template ng-header-tmp>
                      <span class="mbold w-66px">Code</span>
                      <span class="mbold" translate>lblMake</span>
                    </ng-template>

                    <ng-option *ngFor="let type of makeList" [value]="type.brandCode">
                      <span class="w-66px">{{type.brandCode}}</span>
                      <span class="mx-2 hide-ng-dropdown-panel">-</span>
                      <span>{{type.brandName}}</span>
                    </ng-option>
                  </ng-select>
                  <div *ngIf="(cpf.makeCode.invalid) || (cpf.makeCode.invalid && isFormValid)" class="help-block text-danger">
                    <div *ngIf="cpf.makeCode.errors.required"><span translate>lblRequiredMake</span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-3">
              <div class="af-form-group">
                <label for="template-model" translate>lblModel<strong class="mlt6 required">
                    *</strong> </label>
                <div class='lbl-info'>
                  <ng-select formControlName="model" placeholder="{{ 'lblSelectModel' | translate }}" required  [addTag]="true"
                    [(ngModel)]="modelName" [ngClass]="{'ng-select-is-invalid':(cpf.model.invalid ) || (cpf.model.invalid  && isFormValid)}">
                    <ng-option *ngFor="let type of modelList" [value]="type.description">
                      {{type.description}}</ng-option>
                  </ng-select>
                  <div *ngIf="(cpf.model.invalid ) || (cpf.model.invalid && isFormValid)"
                    class="help-block text-danger">
                    <div *ngIf="cpf.model.errors.required"><span translate>lblRequiredModel</span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-3">
              <div class="af-form-group">
                <label for="template-engineSerialNumber" translate="">lblEngineSerialNumber </label>
                <div class="lbl-info">
                  <input type="text" id="template-engineSerialNumber" name="engineSerialNumber" autocomplete="off"
                    formControlName="engineSerialNumber" class="form-control"
                    placeholder="{{ 'lblEnterEngineSerial' | translate }}" maxlength="50">
                </div>
              </div>
            </div>
            <div class="col-3"  style="display: none;">
              <div class="af-form-group">
                <label for="template-compliaceNumber" translate>lblComplianceNo</label>
                <div class="lbl-info">
                  <input type="text" id="template-compliaceNumber" name="compliaceNumber" autocomplete="off"
                    formControlName="compliaceNumber" class="form-control"
                    placeholder="{{ 'lblEnterComplianceNo' | translate }}" maxlength="50">
                </div>
              </div>
            </div>
            
            <div class="col-3">
              <div class="af-form-group">
                <label for="template-mchCode" translate>lblMCHCode</label>
                <div class='lbl-info'>
                  <input type="text" id="template-mchCode" name="mchCode" formControlName="mchCode" class="form-control"
                    placeholder="{{ 'lblEnterMch' | translate }}" maxlength="50">
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="af-form-group">
                <label for="txtregistrationFirstDate" translate>lblFirstRegistrationDate <strong
                    class="required">*</strong></label>
                <div class="lbl-info cal-date">
                  <input class="form-control datePicker width100force" appAfDatepicker [(ngModel)]="registrationFirstDate"
                    autocomplete="off" [startDate]="'1900/01/01'" [dateTime]="false" id="txtregistrationFirstDate"
                    formControlName="registrationFirstDate" name="registrationFirstDate" type="text" value=""
                    [ngClass]="{'ng-select-is-invalid':(cpf.registrationFirstDate.invalid) || (cpf.registrationFirstDate.invalid  && isFormValid)}"
                    [endDate]="endDate">
                  <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                </div>
                <div
                  *ngIf="(cpf.registrationFirstDate.invalid) || (cpf.registrationFirstDate.invalid  && isFormValid)"
                  class="help-block text-danger">
                  <div *ngIf="cpf.registrationFirstDate.errors.required"><span
                      translate>lblRequiredRegistrationFirstDate</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="af-form-group">
                <label for="txtregistrationLastDate" translate>lblLastRegistrationDate</label>
                <div class="lbl-info cal-date">
                  <input class="form-control datePicker width100force" appAfDatepicker [(ngModel)]="registrationLastDate"
                    autocomplete="off" [startDate]="'1900/01/01'" [dateTime]="false" id="txtregistrationLastDate"
                    formControlName="registrationLastDate" name="registrationLastDate" type="text" value=""
                    [endDate]="endDate">
                  <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="af-form-group">
                <label for="txtinspectionPrevDate" translate>lblPrevInspectionDate</label>
                <div class="lbl-info cal-date">
                  <input class="form-control datePicker width100force" appAfDatepicker [(ngModel)]="inspectionPrevDate"
                    autocomplete="off" [startDate]="'1900/01/01'" [dateTime]="false" id="txtinspectionPrevDate"
                    formControlName="inspectionPrevDate" name="inspectionPrevDate" type="text" value=""
                    [endDate]="endDate">
                  <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="af-form-group">
                <label for="txtinspectionNextDate" translate>lblNextInspectionDate</label>
                <div class="lbl-info cal-date">
                  <input class="form-control datePicker width100force" appAfDatepicker [(ngModel)]="inspectionNextDate"
                    autocomplete="off" [startDate]="'1900/01/01'" [dateTime]="false" id="txtinspectionNextDate"
                    formControlName="inspectionNextDate" name="inspectionNextDate" type="text" value="" [ngClass]="vehicleSource == 'DF' || mainVehicleSource == 'DMS' || mainVehicleSourceId == 4 ?'disable':''">
                  <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="af-form-group  mb-0">
                <label for="template-year" translate="">lblYear <strong class="required">*</strong></label>
                <div class="lbl-info">
                  <input type="text" id="template-year" name="year" formControlName="year" class="form-control"
                    placeholder="{{ 'lblYearValid' | translate }}" required maxlength="4" (keypress)="isDigit($event)"
                    [ngClass]="{'ng-select-is-invalid':(cpf.year.invalid) || (cpf.year.invalid  && isFormValid)}">
                  <div *ngIf="(cpf.year.invalid) || (cpf.year.invalid  && isFormValid)" class="help-block text-danger">
                    <div *ngIf="cpf.year.errors.required"><span translate>lblRequiredYear</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="af-form-group">
                <label translate>lblMileage</label>
                <div class="lbl-info relative km-block">
                  <input type="text"  id="template-mileage" class="form-control kminput text-right" name="mileage" formControlName="mileage"
                   min="0" (keypress)="isDigit($event)"  maxlength="9"/>
                   <span class="mil-km">KM</span>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="af-form-group">
                <div class='form-check pl-0 mt-4'>
                  <label for="template-isImported" translate>
                    <input type="checkbox" id="template-isImported" formControlName="isImported" /> lblImportedCar</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
              <div class="col-6">
                <div class="af-form-group">
                  <label for="remark" translate>lblRemark</label>
                  <div class="lbl-info relative">
                    <textarea class="form-control remark-highlight" id="remark" name="remark" formControlName="remark" maxlength="1000">
                    </textarea>
                  </div>
                </div>
              </div>
          </div>
        </div>

        <div class="cst-acc-card mb20">
          <div class="row mb-25">
            <div class="col-12">
              <h2 class="title16 text-primary" translate>lblVehicleSpecification</h2>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <div class="af-form-group crlbl">
                <label for="template-color" translate="">lblColor</label>
                <div class="lbl-info">
                  <input type="text" id="template-color" name="color" formControlName="color" class="form-control"
                    placeholder="{{ 'lblEnterColorName' | translate }}" maxlength="20">
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="af-form-group">
                <label for="template-fueltype" translate>lblFuelType</label>
                <div class='lbl-info'>
                  <ng-select formControlName="fueltype" placeholder="{{ 'lblSelectFuelType' | translate }}"
                    [(ngModel)]="fueltypeName">
                    <ng-template ng-header-tmp>
                      <span class="mbold w-66px">Code</span>
                      <span class="mbold" translate>lblFuelType</span>
                    </ng-template>
  
                    <ng-option *ngFor="let type of fuels" [value]="type.fuelType">
                      <span class="w-66px">{{type.fuelType}}</span>
                      <span class="mx-2 hide-ng-dropdown-panel">-</span>
                      <span>{{type.description}}</span>
                    </ng-option>
                  </ng-select>
  
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="af-form-group">
                <label for="template-vehicleTransmission" translate>lblTransmission</label>
                <div class='lbl-info'>
                  <ng-select formControlName="vehicleTransmission" placeholder="{{ 'lblSelectTransmission' | translate }}"
                      [(ngModel)]="vehicleTransmissionName">
                      <ng-template ng-header-tmp>
                          <span class="mbold w-66px">Code</span>
                          <span class="mbold" translate>lblTransmission</span>
                      </ng-template>
  
                      <ng-option *ngFor="let item of vehicleTransmissionList" [value]="item.code">
                          <span class="w-66px">{{item.code}}</span>
                          <span class="mx-2 hide-ng-dropdown-panel">-</span>
                          <span>{{item.transmisionName}}</span>
                      </ng-option>
                  </ng-select>
              </div>
  
              </div>
            </div>
            <div class="col-3">
              <div class="af-form-group">
                <label for="template-totalWeight" translate>lblTotalWeight</label>
                <div class='lbl-info'>
                  <input type="text" id="template-totalWeight" name="totalWeight" (keypress)="isDigit($event)"
                    formControlName="totalWeight" class="form-control"
                    placeholder="{{ 'lblEnterTotalWeight' | translate }}" maxlength="6">
                </div>
              </div>
            </div>
  
            <div class="col-3">
              <div class="af-form-group">
                <label for="template-curbWeight" translate>lblCurbWeight</label>
                <div class='lbl-info'>
                  <input type="text" id="template-curbWeight" name="curbWeight" (keypress)="isDigit($event)"
                    formControlName="curbWeight" class="form-control" placeholder="{{ 'lblEnterCurbWeight' | translate }}"
                    maxlength="6">
                </div>
              </div>
            </div>
  
            <div class="col-3">
              <div class="af-form-group">
                <label for="template-numberOfAxles" translate>lblNumberOfAxles</label>
                <div class='lbl-info'>
                  <input type="text" id="template-numberOfAxles" name="numberOfAxles" (keypress)="isDigit($event)"
                    formControlName="numberOfAxles" class="form-control"
                    placeholder="{{ 'lblEnterNumberOfAxles' | translate }}" maxlength="6">
                </div>
              </div>
            </div>
  
            <div class="col-3">
              <div class="af-form-group">
                <label for="template-axleWeightLimitFront" translate>lblAxleWeightLimitFront</label>
                <div class='lbl-info'>
                  <input type="text" id="template-axleWeightLimitFront" name="axleWeightLimitFront"
                    (keypress)="isDigit($event)" formControlName="axleWeightLimitFront" class="form-control"
                    placeholder="{{ 'lblEnterAxleWeightLimitFront' | translate }}" maxlength="6">
                </div>
              </div>
            </div>
  
            <div class="col-3">
              <div class="af-form-group">
                <label for="template-axleWeightLimitRear" translate>lblAxleWeightLimitRear</label>
                <div class='lbl-info'>
                  <input type="text" id="template-axleWeightLimitRear" name="axleWeightLimitRear"
                    (keypress)="isDigit($event)" formControlName="axleWeightLimitRear" class="form-control"
                    placeholder="{{ 'lblEnterAxleWeightLimitRear' | translate }}" maxlength="6">
                </div>
              </div>
            </div>

            <div class="col-3">
              <div class="af-form-group">
                <label for="template-noOfCylinder" translate>lblNoOfCylinder</label>
                <div class='lbl-info'>
                  <input type="text" id="template-noOfCylinder" name="noOfCylinder"
                    (keypress)="isDigit($event)" formControlName="noOfCylinder" class="form-control"
                    placeholder="{{ 'lblEnterNoOfCylinder' | translate }}" maxlength="6">
                </div>
              </div>
            </div>

            <div class="col-3">
              <div class="af-form-group">
                <label for="template-cylinderCapacity" translate>lblCylinderCapacityCCM</label>
                <div class='lbl-info'>
                  <input type="text" id="template-cylinderCapacity" name="cylinderCapacity" (keypress)="isDigit($event)"
                    formControlName="cylinderCapacity" class="form-control"
                    placeholder="{{ 'lblEntercylinderCapacity' | translate }}" maxlength="6">
                </div>
              </div>
            </div>

            <div class="col-3">
              <div class="af-form-group">
                <label for="template-powerKW" translate>lblPowerKW</label>
                <div class='lbl-info'>
                  <input type="text" id="template-powerKW" name="powerKW"
                    (keypress)="isDigit($event)" formControlName="powerKW" class="form-control"
                    placeholder="{{ 'lblEnterPowerKW' | translate }}" maxlength="6">
                </div>
              </div>
            </div>

            <div class="col-3">
              <div class="af-form-group">
                <label for="template-powerHP" translate>lblPowerHP</label>
                <div class='lbl-info'>
                  <input type="text" id="template-powerHP" name="powerHP"
                    (keypress)="isDigit($event)" formControlName="powerHP" class="form-control"
                    placeholder="{{ 'lblEnterPowerHP' | translate }}" maxlength="6">
                </div>
              </div>
            </div>

            <div class="col-3">
              <div class="af-form-group">
                <label for="template-noOfDoors" translate>lblNoOfDoors</label>
                <div class='lbl-info'>
                  <input type="text" id="template-noOfDoors" name="noOfDoors"
                    (keypress)="isDigit($event)" formControlName="noOfDoors" class="form-control"
                    placeholder="{{ 'lblEnterNoOfDoors' | translate }}" maxlength="6">
                </div>
              </div>
            </div>

            <div class="col-3">
              <div class="af-form-group">
                <label for="template-noOfSeats" translate>lblNoOfSeats</label>
                <div class='lbl-info'>
                  <input type="text" id="template-noOfSeats" name="noOfSeats"
                    (keypress)="isDigit($event)" formControlName="noOfSeats" class="form-control"
                    placeholder="{{ 'lblEnterNoOfSeats' | translate }}" maxlength="6">
                </div>
              </div>
            </div>

            <div class="col-3">
              <div class="af-form-group">
                <label for="template-drive" translate>lblDrive</label>
                <div class='lbl-info'>
                        <ng-select formControlName="drive" placeholder="{{ 'lblSelectDrive' | translate }}" [(ngModel)]="driveName" >                        
                          <ng-option [value]="0" translate disabled>
                            lblSelectDrive
                           </ng-option>
                          <ng-option *ngFor="let item of driveDropdownValue" [value]="item.value">
                           {{item.name}}
                          </ng-option>
                        </ng-select>
                </div>
              </div>
            </div>

            <div class="col-3">
              <div class="af-form-group">
                
                <div class='form-check pl-0 mt-4'>
                  <label for="template-fourWD" translate>
                    <input type="checkbox" id="template-fourWD" formControlName="fourWD" /> lbl4WD</label>
                    
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cst-acc-card mb20" style="display: none;">
        <div class="row mb-25">
          <div class="col-12">
            <h2 class="title16 text-primary" translate>lblTyreInformation</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <div class="af-form-group">
              <label for="template-tyreDimensionFront" translate>lblTyreDimensionFront</label>
              <div class='lbl-info'>
                <input type="text" id="template-tyreDimensionFront" name="tyreDimensionFront"
                  formControlName="tyreDimensionFront" class="form-control"
                  placeholder="{{ 'lblEnterTyreDimensionFront' | translate }}" maxlength="20">
              </div>
            </div>
          </div>

          <div class="col-3">
            <div class="af-form-group">
              <label for="template-tyreDimensionRear" translate>lblTyreDimensionRear</label>
              <div class='lbl-info'>
                <input type="text" id="template-tyreDimensionRear" name="tyreDimensionRear"
                  formControlName="tyreDimensionRear" class="form-control"
                  placeholder="{{ 'lblEnterTyreDimensionRear' | translate }}" maxlength="20">
              </div>
            </div>
          </div>

          <div class="col-3">
            <div class="af-form-group">
              <label for="template-tyreLoadIndexFront" translate>lblTyreLoadIndexFront</label>
              <div class='lbl-info'>
                <input type="text" id="template-tyreLoadIndexFront" name="tyreLoadIndexFront"
                  formControlName="tyreLoadIndexFront" class="form-control"
                  placeholder="{{ 'lblEnterTyreLoadIndexFront' | translate }}" maxlength="20">
              </div>
            </div>
          </div>

          <div class="col-3">
            <div class="af-form-group">
              <label for="template-tyreLoadIndexRear" translate>lblTyreLoadIndexRear</label>
              <div class='lbl-info'>
                <input type="text" id="template-tyreLoadIndexRear" name="tyreLoadIndexRear"
                  formControlName="tyreLoadIndexRear" class="form-control"
                  placeholder="{{ 'lblEnterTyreLoadIndexRear' | translate }}" maxlength="20">
              </div>
            </div>
          </div>

          <div class="col-3">
            <div class="af-form-group">
              <label for="template-tyreSpeedIndexFront" translate>lblTyreSpeedIndexFront</label>
              <div class='lbl-info'>
                <input type="text" id="template-tyreSpeedIndexFront" name="tyreSpeedIndexFront"
                  formControlName="tyreSpeedIndexFront" class="form-control"
                  placeholder="{{ 'lblEnterTyreSpeedIndexFront' | translate }}" maxlength="20">
              </div>
            </div>
          </div>

          <div class="col-3">
            <div class="af-form-group">
              <label for="template-tyreSpeedIndexRear" translate>TyreSpeedIndexRear</label>
              <div class='lbl-info'>
                <input type="text" id="template-tyreSpeedIndexRear" name="tyreSpeedIndexRear"
                  formControlName="tyreSpeedIndexRear" class="form-control"
                  placeholder="{{ 'lblEnterTyreSpeedIndexRear' | translate }}" maxlength="20">
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="card  scrollbar longtab" *ngIf="!showVehicleEditForm">
    <div class="px-3" *ngIf="!showVehicleEditForm && vehicleList.length > 0 && IsSearch">
      <div class="row">
        <div class="col-12 d-flex mb-3">
          <button type="button" aria-label="Center Align" class="add-button btn btn-primary ml-auto py-2 px-3"
            (click)="toggleVehicleEditFormFn()" *ngIf="userRoleRightsDetails.canAdd" translate>
            lblAddNewVehicle
          </button>
        </div>
        <div class="col-12">
          <div class="table-responsive tableMx-15">
            <table class="tablest1">
              <thead>
                <tr>
                  <th scope="col" style="width: 5%" translate>#</th>
                  <th scope="col" style="width: 150px" sortable="licensePlate" (sort)="onSort($event)" translate>
                    lblRegNumber</th>
                  <th scope="col" sortable="chassisNo" (sort)="onSort($event)" translate>lblVinNumber</th>
                  <th scope="col" sortable="companyMakeName" (sort)="onSort($event)" translate>Make</th>
                  <th scope="col" translate>lblColor</th>
                  <th scope="col" translate>lblYear</th>
                  <th scope="col" translate>lblRegistrationDate</th>
                  <th scope="col" translate>lblVehicleStatus</th>
                  <th scope="col" translate>lblFuelType</th>
                  <th scope="col" sortable="ownerType" (sort)="onSort($event)" class="text-center" translate>lblRelation
                  </th>
                  <th scope="col" style="width: 75px" class="text-center" translate>lblAction</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="vehicleList?.length>0; else load_NotFound_Template">
                  <tr *ngFor="let item of vehicleList; let i=index">
                    <td>{{ item.rowNumber }}</td>
                    <td>
                      <div class="flmid">
                        <div class="licplate LPNo d-flex">
                          <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                          {{item.licensePlate}}
                        </div>
                        <div class="imgWid">
                          <ng-container>
                            <img af-brand-logo [data-code]="item.companyMakeCode" data-type="BRAND" class="{{item.companyMakeCode}}-icon brandicon"
                              alt="not found" />
                          </ng-container>
                        </div>
                      </div>
                    </td>
                    <td>
                      <ngb-highlight [result]="item.chassisNo" [term]="pService.searchTerm">
                      </ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="item.companyMakeName" [term]="pService.searchTerm">
                      </ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="item.color" [term]="pService.searchTerm">
                      </ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="item.year" [term]="pService.searchTerm"></ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="item.registrationDate" [term]="pService.searchTerm">
                      </ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="item.vehicleGroup" [term]="pService.searchTerm">
                      </ngb-highlight>
                    </td>
                    <td>
                      {{item.fuelType}}
                    </td>

                    <td>
                      {{item.ownerType}}
                    </td>
                    <td class="text-center">
                      <div class="d-flex">
                        <a class="btn btn-ico" ngbTooltip="{{'lblView' | translate}}" tooltipClass="custom-revert" *ngIf="userRoleRightsDetails.canView"
                          (click)="editVehicleDetails(item.vehicleId,1)">
                          <em class="far fa-eye fa-lg"></em>
                        </a>
                        <span class="ico-div"></span>
                        <a class="btn btn-ico"  ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert"
                          (click)="deleteVehicle(item.vehicleId,item.chassisNo)" *ngIf="userRoleRightsDetails.canDelete">
                          <em class="far fa-trash-alt fa-lg"></em>
                        </a>
                      </div>
                    </td>
                  </tr>
                </ng-container>
                <ng-template #load_NotFound_Template>
                  <tr>
                    <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                  </tr>
                </ng-template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="p-3 bg-light pp-footer-top-brdr">
    <div class="row">
      <div class="col-4">
        <ng-container *ngIf="showVehicleEditForm && vehicleList.length > 0">
          <button type="button" class="add-button btn btn-secondary btn-lg" (click)="toggleVehicleEditFormFn()"
            translate><em class="far fa-arrow-left font16 align-top mr-2"></em> lblBack</button>
        </ng-container>
      </div>
      <div class="col-8 d-flex flex-sm-row flex-column justify-content-end">
        <button type="button" class="add-button btn btn-primary btn-lg mr-3" *ngIf="(userRoleRightsDetails.canAdd && showVehicleEditForm &&  !isView)"
          (click)="SaveButtonEvent(false)"
          translate><em class="far fa-save font16 align-top mr-2"></em> lblSave</button>
          <button type="button" class="add-button btn btn-primary btn-lg mr-3" *ngIf=" (userRoleRightsDetails.canAdd && showVehicleEditForm &&  !isView)"
          (click)="SaveButtonEvent(true)"
          translate><em class="far fa-save font16 align-top mr-2"></em> lblSaveAndClose</button>
        <ng-container>
          <button type="button" class="add-button btn btn-secondary btn-lg" (click)="OnClose()"
            translate><em class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</button>
        </ng-container>

      </div>
    </div>
  </div>
</form>